import { QueryClient } from '@tanstack/react-query';

/**
 * ONE CLIENT, REACHABLE FROM OUTSIDE REACT.
 *
 * Route loaders run before a route renders and have no context to read a
 * client from, so the client is a module singleton that `main.tsx` hands to
 * the provider and the loaders import directly. Tests import the same one
 * and clear it between cases.
 */
export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      // The pipeline is poll-first: a stale window would make a scene list look
      // frozen while extraction is actively filling it in.
      staleTime: 0,
      retry: 1,
    },
  },
});
